export type GetSignedPhotoUrlRequest = {
  path: string;
};

export type GetSignedPhotoUrlResponse = {
  url: string;
};
